"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AiNoticeGate = require("@common/components/AiNoticeGate");
var _aiNoticeGate = require("@common/utils/ai-notice-gate");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _AuthContext = require("../../context/AuthContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AddinAiNoticeGate(_ref) {
  var _orgHelper$getOrgIds$, _user$userId, _org$orgMetadata;
  var children = _ref.children;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    authStatus = _useAuthInfo.authStatus,
    user = _useAuthInfo.user,
    orgHelper = _useAuthInfo.orgHelper;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var isAuthenticated = authStatus === "authenticated";
  var orgId = isAuthenticated ? (_orgHelper$getOrgIds$ = orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrgIds()[0]) !== null && _orgHelper$getOrgIds$ !== void 0 ? _orgHelper$getOrgIds$ : null : null;
  var userId = isAuthenticated ? (_user$userId = user === null || user === void 0 ? void 0 : user.userId) !== null && _user$userId !== void 0 ? _user$userId : null : null;
  var org = orgId ? orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrg(orgId) : null;
  function trackAcknowledged(notice) {
    if (!analytics || !orgId || !userId) return;
    analytics.track(_aiNoticeGate.AI_NOTICE_ACKNOWLEDGED_EVENT, (0, _aiNoticeGate.aiNoticeAcknowledgedEventProps)({
      orgId: orgId,
      userId: userId,
      noticeVersion: notice.version,
      surface: "word-addin"
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AiNoticeGate.AiNoticeGate, {
    orgId: orgId,
    userId: userId,
    orgMetadata: (_org$orgMetadata = org === null || org === void 0 ? void 0 : org.orgMetadata) !== null && _org$orgMetadata !== void 0 ? _org$orgMetadata : null,
    onAcknowledged: trackAcknowledged,
    "data-sentry-element": "AiNoticeGate",
    "data-sentry-component": "AddinAiNoticeGate",
    "data-sentry-source-file": "AddinAiNoticeGate.tsx",
    children: children
  });
}
var _default = exports.default = AddinAiNoticeGate;